import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Map } from 'features/map';
import { Stores } from 'features/stores/stores';
import { Store } from 'features/stores/types';
import { StoreInfoMobile } from 'features/stores/components/store-info-mobile';
import { sectionStyle } from 'common/styles/section';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { setActiveStore } from 'features/stores';
import { getStoresList, getActiveStore } from 'features/stores/ducks/get-stores';
import { activeRegionActions } from 'features/active-region';
import { getActiveRegionId } from 'features/active-region/ducks/selectors';
import { getRegionId } from 'features/page-model/ducks/get-model';
import { cx } from 'linaria';
import { contentStyle } from './style';

export const Content: FC = () => {
  const { desktop, largeDesktop } = useBreakpoints() ?? {};
  const dispatch = useDispatch();
  const stores = useSelector(getStoresList);
  const regionId = useSelector(getRegionId);
  const activeStore = useSelector(getActiveStore);
  const activeRegionId = useSelector(getActiveRegionId);
  const isDesktop = desktop || largeDesktop;

  const setActive = useCallback(
    (store: Store | null) => {
      dispatch(setActiveStore(store));
    },
    [dispatch],
  );

  const setRegion = useCallback(
    (id: string) => {
      dispatch(activeRegionActions.setActiveRegionId(id));
    },
    [dispatch],
  );

  return (
    <section className={cx(sectionStyle, contentStyle)}>
      <Map
        storeList={stores}
        regionId={regionId}
        activeStore={activeStore}
        activeRegionId={activeRegionId}
        setActiveStore={setActive}
        setActiveRegionId={setRegion}
      />
      <Stores />
      {!isDesktop && activeStore && (
        <StoreInfoMobile
          activeRegionId={activeRegionId}
          store={activeStore}
          onClose={() => setActive(null)}
        />
      )}
    </section>
  );
};
